import styled from "styled-components";
import * as PropTypes from "prop-types";

export default function SubHeader({ children, center, extraMargin }) {
  return (
    <Header4 center={center} extraMargin={extraMargin}>
      {children}
    </Header4>
  );
}

const Header4 = styled.h4`
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  margin: 0;
  margin-bottom: ${({ extraMargin }) => (extraMargin ? "1.5rem" : 0)};
  ${({ center }) => center && "text-align: center"};
`;

SubHeader.propTypes = {
  children: PropTypes.any,
  center: PropTypes.bool,
  extraMargin: PropTypes.bool,
};
